import { render, staticRenderFns } from "./SelectCustomersMultiple.vue?vue&type=template&id=6724e615"
import script from "./SelectCustomersMultiple.vue?vue&type=script&lang=js"
export * from "./SelectCustomersMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports